import { createContext } from "react";

//form error

//form info
export interface IKnowledgeGrpManagementFormContext {
  mode: "Edit" | "Add" | "Info";
}
export const KnowledgeGrpManagementFormContext = createContext<IKnowledgeGrpManagementFormContext | null>(null);
